module.exports = __webpack_public_path__ + "static/ai-1-2e5bc32be5ebac70b22d622d9ab55a4c.png";